import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, pairwise } from 'rxjs/operators';
import { UserSessionModel } from '../../user/models/user-session.model';
import { PlatformRouterLinks } from '../../common/common.const';
import { PlatformNavigationService } from '../../common/services/platform-navigation.service';

@Injectable({
	providedIn: 'root',
})
export class PreviousRouteService implements OnDestroy {
	public excludedUrls: string[] = [
		'/pageNotFound',
		PlatformRouterLinks.login,
		'/platform/agency/pageNotFound',
		'/platform/agency/doNotHavePermission',
	];
	public previousUrl: string = '';
	public currentUrl: string = '';
	private routerSubscription: Subscription = new Subscription();

	constructor(private router: Router) {
		this.currentUrl = this.router.url;

		this.routerSubscription = this.router.events
			.pipe(
				filter((event): event is NavigationEnd => event instanceof NavigationEnd),
				pairwise(),
			)
			.subscribe(([previousEvent, currentEvent]) => {
				if (
					this.excludedUrls.find((u) => u !== previousEvent.urlAfterRedirects) &&
					(PlatformNavigationService.getProtectedNavLink(PlatformRouterLinks.dashboard, PlatformRouterLinks.agency) !== previousEvent.urlAfterRedirects && !(new UserSessionModel().isInternal()))
				) {
					this.previousUrl = previousEvent.urlAfterRedirects;
				}
				this.currentUrl = currentEvent.urlAfterRedirects;
			});
	}

	ngOnDestroy(): void {
		this.routerSubscription.unsubscribe();
	}
}
